import { Directive, HostListener } from '@angular/core';
import { Observable } from 'rxjs';

@Directive()
export abstract class CanComponentDeactivate {
    abstract canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}
